import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { fetchAdminAuditLogs } from 'utils/api/logsApi'
import { calculateOffset } from 'utils/helpers/pagination'
import { getAdminAuditLogColumns } from './utils'
import { filterEmptyValues } from 'utils/helpers'
import useModal from 'hooks/useModal'
import { ICellRendererParams } from '@ag-grid-community/core'
import AuditLogChangesModal from './auditLogChangesModal'

const AdminAuditLogTable = () => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [page, setPage] = useState<number>(0)
  const [selectedLog, setSelectedLog] = useState<any | null>(null)

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const { isOpen, openModal, closeModal } = useModal()

  const handleViewLog = (params: ICellRendererParams) => {
    setSelectedLog(params.data)
    openModal()
  }

  const handleCloseModal = () => {
    closeModal()
    setSelectedLog(null)
  }

  const columns = useMemo(
    () => getAdminAuditLogColumns(page, handleViewLog),
    [page],
  )

  // To get ERP Log data
  const getLogs = async () => {
    try {
      const { limit, page, adminAuditLogFilters } = getAllQueries()

      // removing empty values and keys
      const filters = filterEmptyValues(adminAuditLogFilters)

      const { data } = await fetchAdminAuditLogs({
        limit: limit || 10,
        page: page || 1,
        filters,
      })
      setPage(calculateOffset(data))
      setLogResponse(data)
    } catch (error) {
      setLogResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      <AuditLogChangesModal
        log={selectedLog}
        isOpen={isOpen}
        onClose={handleCloseModal}
      />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}

export default AdminAuditLogTable
